import gql from 'graphql-tag'

const GET_PROJECT_ASSET_TYPES = gql`
  query projectAssetTypes($tenantId: Int!, $offset: Int, $limit: Int) {
    projectAssetTypes(tenantId: $tenantId, offset: $offset, limit: $limit) {
      total
      data {
        id
        name
      }
    }
  }
`

export { GET_PROJECT_ASSET_TYPES }